/**
 * Fixed calendar-week bounds for scoreboard date view.
 * Sunday–Saturday so the same week yields the same query key (cache hit when switching days).
 */

import { startOfWeek, endOfWeek, parseISO } from 'date-fns';

/** Week starts on Sunday (0) for stable boundaries. */
const WEEK_STARTS_ON = 0;

export interface WeekRange {
  start: string;
  end: string;
}

/** Format a Date to YYYY-MM-DD (for query keys and calendar state). */
export function formatDateToYYYYMMDD(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Returns the calendar week (Sunday–Saturday) that contains the given date.
 * @param dateYYYYMMDD - Date string YYYY-MM-DD
 * @returns { start, end } in YYYY-MM-DD
 */
export function getWeekRangeForDate(dateYYYYMMDD: string): WeekRange {
  const date = parseISO(dateYYYYMMDD);
  const start = startOfWeek(date, { weekStartsOn: WEEK_STARTS_ON });
  const end = endOfWeek(date, { weekStartsOn: WEEK_STARTS_ON });
  return {
    start: formatDateToYYYYMMDD(start),
    end: formatDateToYYYYMMDD(end),
  };
}
